import Vue from "vue";
import DefaultDefault from "../models/Default.js";
import globalStore from '../models/variables.js';




var publicNavApp = new Vue({
    el: '#PublicNavBarApp',
    name: "PublicNavApp",
    data: {
        benefit: globalStore,

        navBarItems: [],
        
        pageName: "",
        imageLink: "https://www.mydrugbenefit.com/PatientDashboard_sh/images/SH_Prescriptions_PMS152.gif",
        

    },

    methods: {
        loadDefaults: function () {
            var me = this;

            Default.GetForView("navbar").then(function (res) {
                me.defaults = res.data;
            });
        },
        getDefault: function (nameKey) {
            return Default.Find(nameKey, this.defaults);
        },
        setTitle: function () {
            this.pageName = $("title")[0].innerText;

        },
        removeBenefitMultiformulary: function () {
            var title = $("title")[0].innerText;
            if (title == "MultiFormulary Drug Search") {
                this.benefit = "";
            }
        },
       
        logout: function () {
            var me = this;
            this.$buefy.dialog.confirm({
                message: me.getDefault("logout_confirm"),
                onConfirm: function () {
                    ApiAuth.logout();
                    me.$buefy.toast.open({
                        message: me.getDefault("logout_success"),
                    });
                    setTimeout(function () {
                        window.location.href = Apollo.resolveAppUrl("~");
                    }, 1500);
                }
            });

        }
    },
    mounted: function() {
        this.setTitle();
        this.removeBenefitMultiformulary();
    }
 
});

$(document).ready(function () {

    // Check for click events on the navbar burger icon
    $(".navbar-burger").click(function () {
        // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
        $(".navbar-burger").toggleClass("is-active");
        $(".navbar-menu").toggleClass("is-active");

    });
});




// WEBPACK FOOTER //
// ./src/apps/PublicNavBarApp.js